import { ThemeColors } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

type Props = {
  hasIslands: boolean
  lightBg: boolean
}

export const OptionalDivider: React.FC<Props> = ({ hasIslands, lightBg }) => {
  if (hasIslands) {
    return null
  }

  // todo: rename to avoid conflict lightTheme = sheetDarkTheme
  return (
    <div
      className={clsJoin(css.previewDivider, lightBg && ThemeColors.light)}
    />
  )
}
